class DepositReportsController {
  /*@ngInject*/
  constructor() {}
  $onInit() {}
}

export default DepositReportsController; 



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/deposit_reports/deposit_reports.controller.js